<template>
  <div>
    <Form
      :error="error"
      :error-text="error"
      :success="success"
      :success-text="success"
      @submit="submit"
    >
      <div class="top-window">
        <div class="heading1 heading1-line">Настройки пользователя</div>
      </div>
      <div class="form-block">
        <div class="h4">Общие настройки</div>

        <Formcell
          v-model="general.name"
          id="change-name"
          :label="tellMe('nameOrCompany')"
        />

        <div class="_2-fields">
          <Formcell
            v-model="general.email"
            id="change-email"
            class="formcell-mb0"
            label="Email"
            type="email"
          />
          <Formcell
            v-model="general.phone"
            id="change-tel"
            class="formcell-mb0"
            label="Телефон"
            type="tel"
          />
        </div>
      </div>

      <div class="divider" />
      <div class="form-block">
        <div class="h4">Изменение пароля</div>
        <div class="_2-fields">
          <Formcell
            v-model="pass.pass"
            id="change-pass-confirm"
            class="formcell-mb0"
            label="Введите старый пароль"
            type="password"
          />
          <Formcell
            v-model="pass.passc"
            id="change-pass"
            class="formcell-mb0"
            label="Введите новый пароль"
            type="password"
          />
        </div>
      </div>

      <Submit :loading="isLoading" usual text="Сохранить изменения" />
    </Form>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex';
  import Form from '@/components/Form';
  import Formcell from '@/components/Formcell';
  import Submit from '@/components/Submit';
  import tellMe from '@/utils/accessStrings';
  import {email, minLength, required} from 'vuelidate/lib/validators';
  import factory from '@/utils/api/factory';
  import parseError from '@/utils/api/parse-error';

  const ERRORS = {
    none: 'Пожалуйста, заполните либо три поля (Имя, Email и номер телефона), либо введите новый пароль.',
    name: 'Поле имени не может быть пустым.',
    email: 'Поле Email не может быть пустым.',
    phone: 'Поле номера телефона не может быть пустым.',
    oldP: 'Поле прежнего пароля не может быть пустым.',
    newP: 'Поле нового пароля не может быть пустым.',
    something: 'Что-то пошло не так.',
  };

  const SUCCESS = {
    all: 'Все поля успешно заменены!',
    general: 'Основная информация успешно заменена!',
    passwords: 'Пароль успешно заменен!',
  };

  export default {
    name: 'UserSettings',
    components: {Submit, Formcell, Form},
    data () {
      return {
        general: {
          name: this.$store.state.auth?.user?.name || '',
          email: this.$store.state.auth?.user?.email || '',
          phone: this.$store.state.auth?.user?.phone_number || '',
        },
        pass: {
          pass: '',
          passc: '',
        },
        isLoading: false,
        error: null,
        success: null,
      };
    },
    validations: {
      general: {
        email: {required, email},
        name: {required, minLength: minLength(2)},
        phone: {required, minLength: minLength(5)},
      },
      pass: {
        pass: {required, minLength: minLength(6)},
        passc: {required, minLength: minLength(6)},
      },
    },
    computed: mapState({
      user: state => state.auth.user,
    }),
    methods: {
      tellMe,
      ...mapMutations({
        setUser: 'auth/setUser',
      }),
      async submit () {
        const fields = this.validate();
        if (!fields) return;
        this.isLoading = true;

        if (fields === 'general') {
          await this.sendGeneral();
          this.success = SUCCESS.general;
        } else if (fields === 'password') {
          await this.sendPassword();
          this.success = SUCCESS.passwords;
        } else if (fields === 'all') {
          await Promise.all([
            this.sendGeneral(),
            this.sendPassword()
          ]);
          this.success = SUCCESS.all;
        }

        this.isLoading = false;
      },
      async sendGeneral () {
        try {
          const {data} = await factory('auth').patchInPath('profile', {
            email: this.general.email,
            phone_number: this.general.phone,
            name: this.general.name,
          });
          this.setUser(data);
        } catch (e) {
          this.error = parseError(e) || ERRORS.something;
          this.isLoading = false;
        }
      },
      async sendPassword () {
        try {
          await factory('auth').postInResourcePath('profile', 'change_password', {
            old_password: this.pass.pass,
            new_password: this.pass.passc,
          });
        } catch (e) {
          this.error = parseError(e) || ERRORS.something;
          this.isLoading = false;
        }
      },
      didUserInfoChange () {
        const user = this?.user || {};
        return (user.name !== this.general.name || user.phone_number !== this.general.phone || user.email !== this.general.email);
      },
      validate () {
        this.error = null;
        this.success = null;

        this.$v.$touch();
        if ((!this.$v.general.$invalid && this.didUserInfoChange()) && !this.$v.pass.$invalid) return 'all';
        else if (!this.$v.general.$invalid && this.didUserInfoChange()) return 'general';
        else if (!this.$v.pass.$invalid) return 'password';
        else {
          if (!this.$v.pass.pass.$invalid && this.$v.pass.passc.$invalid) this.error = ERRORS.newP;
          else if (this.$v.pass.pass.$invalid && !this.$v.pass.passc.$invalid) this.error = ERRORS.oldP;
          else if (this.$v.general.name.$invalid) this.error = ERRORS.name;
          else if (this.$v.general.email.$invalid) this.error = ERRORS.email;
          else if (this.$v.general.phone.$invalid) this.error = ERRORS.phone;
          else this.error = ERRORS.none;

          return null;
        }
      },
    },
  };
</script>

<style lang="scss">
  textarea{
    resize: vertical;
  }
  .popup-setteings {
    .w-form-fail, .w-form-done {
      margin-top: 100px;
      max-width: 480px;
    }

    @media screen and (max-width: 768px) {
      .w-form-fail, .w-form-done {
        margin-top: 10px;
      }
    }

    .w-button, .btn-wrap {
      width: 100%;
    }

    input[type="submit"] {
      width: 100%;
    }
  }
</style>
